module.exports = __webpack_public_path__ + "img/crystal.8d53801c.svg";